import React from 'react';
import Badge, { BadgeProps } from '.';
import { getStatusColor, getStatusLabel, StatusType } from 'constant';

interface BadgeStatusProps extends BadgeProps {
  status: StatusType;
}

const BadgeStatus: React.FC<BadgeStatusProps> = ({ status, styleVariant = 'subtle', ...props }) => {
  return (
    <Badge
      {...props}
      styleVariant={styleVariant}
      bg={getStatusColor(status.toLowerCase() as StatusType)}
    >
      {getStatusLabel(status.toLowerCase() as StatusType)}
    </Badge>
  );
};

export default BadgeStatus;
